import React from 'react'

export default class IconsArrowLeftLight extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'

        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
            >
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M9.707 14.695C9.51947 14.8825 9.26516 14.9878 9 14.9878C8.73484 14.9878 8.48053 14.8825 8.293 14.695L4.293 10.695C4.10553 10.5075 4.00021 10.2532 4.00021 9.98801C4.00021 9.72284 4.10553 9.46854 4.293 9.28101L8.293 5.28101C8.4816 5.09885 8.7342 4.99806 8.9964 5.00034C9.2586 5.00261 9.50941 5.10778 9.69482 5.29319C9.88023 5.4786 9.9854 5.72941 9.98767 5.99161C9.98995 6.25381 9.88916 6.50641 9.707 6.69501L7.414 8.98801H15C15.2652 8.98801 15.5196 9.09337 15.7071 9.2809C15.8946 9.46844 16 9.72279 16 9.98801C16 10.2532 15.8946 10.5076 15.7071 10.6951C15.5196 10.8827 15.2652 10.988 15 10.988H7.414L9.707 13.281C9.89447 13.4685 9.99979 13.7228 9.99979 13.988C9.99979 14.2532 9.89447 14.5075 9.707 14.695Z'
                    fill='#595C61'
                />
            </svg>
        )
    }
}
